import { ProtectedRoute } from "@/components/ProtectedRoute";
import { PublicRoute } from "@/components/PublicRoute";
import { Navigate, Route, Routes } from "react-router-dom";
import { authRoutes, protectedRoutes, publicRoutes } from "./routes";

const AppRouter = () => {
  return (
    <Routes>
      {/* Auth routes (login, signup) - redirect authenticated users to dashboard */}
      {authRoutes.map(({ path, Component }) => (
        <Route
          key={path}
          path={path}
          element={
            <PublicRoute>
              <Component />
            </PublicRoute>
          }
        />
      ))}

      {/* Public routes available for everyone */}
      {publicRoutes.map(({ path, Component }) => (
        <Route key={path} path={path} element={<Component />} />
      ))}

      {/* Routes avaliable only for logged in users */}
      {protectedRoutes.map(({ path, Component }) => (
        <Route
          key={path}
          path={path}
          element={
            <ProtectedRoute>
              <Component />
            </ProtectedRoute>
          }
        />
      ))}

      {/* Redirect to the /dashboard route if none of the above routes are matched. If user is not logged in redirects from /dashboard to /login */}
      <Route path="*" element={<Navigate to={"/dashboard"} replace />} />
    </Routes>
  );
};

export { AppRouter };
